if(window.globalVariables.template == 'product'){

const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
        if(document.querySelector('.mobile-select') != null){
            this.mobile_select();
        } 
      

            // Custom code for product page goes here
            // const io = new IntersectionObserver((entries) => {
            //     entries.forEach((entry) => {
            //       if(entry.isIntersecting){
            //         document.body.classList.remove('sticky-cart-show');
            //       }else{
            //         document.body.classList.add('sticky-cart-show')
            //       }
            //     })
            //   })
            //   io.observe(document.querySelector('[data-slider_type]'))
    }
    mobile_select(){
        document.querySelector('.mobile-select').addEventListener('click', (e)=>{
            e.preventDefault();
            let currentTarget = e.target;
            let isOpen = currentTarget.classList.contains('active');
            let next_element = currentTarget.nextElementSibling;
            if(isOpen){
                currentTarget.classList.remove('active');
                next_element.classList.remove('active');
            }else{
                currentTarget.classList.add('active');
                next_element.classList.add('active');
            }
        })

        document.body.addEventListener('click', (event)=> {
            let currentEle = event.target;
            if (currentEle.classList.contains('select_tab')) {
                return;
            }else{
            let isOpen = document.querySelector('.mobile-select').classList.contains('active');
                if(isOpen){
                    document.querySelector('.mobile-select').classList.remove('active');
                    document.querySelector('.mobile-select').nextElementSibling.classList.remove('active');
                }
            }
          });

          let select = document.querySelector('.projects-tabs');
          let options = select.querySelectorAll('li');
  
          options.forEach(option => option.addEventListener('click', (event) =>{
              let _this = event.currentTarget;
               document.querySelector('.mobile-select').querySelector('span:first-child').innerText =  _this.querySelector('a').innerText;
               document.querySelector('.mobile-select').classList.remove('active');
              document.querySelector('.mobile-select').nextElementSibling.classList.remove('active');
              }));
    }
}

    typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();


    function isSectionVisible() {
    let footer = document.querySelector('.product-des-wrap');
    if (!footer) {
        // When description section isn't on the page use the product info wrapper instead.
        footer = document.querySelector('[data-product-container] .container')
    }
    const footerRect = footer.getBoundingClientRect();
    return footerRect.top > window.innerHeight;
    }

    function toggleBodyClass() {
    const body = document.body;
    if (isSectionVisible()) {
        body.classList.add('visible');
    } else {
        body.classList.remove('visible');
    }
    }

// Initial check and listen for scroll and resize events
toggleBodyClass();
window.addEventListener('scroll', toggleBodyClass);
window.addEventListener('resize', toggleBodyClass);
}

if(window.globalVariables.template == 'index'){

/*=============================================
=            Testimonial Slider Start           =
=============================================*/

var testiThumbs = new Swiper(".testimonial-thumbnails", {
    slidesPerView: 1,
    grabCursor: true
});
var testiMain = new Swiper(".testimonial-list", {
    slidesPerView: 1,
    grabCursor: true,
    navigation: {
      nextEl: '.testimonial-arrow-next',
      prevEl: '.testimonial-arrow-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});

testiMain.on('slideChangeTransitionStart', function() {
    testiThumbs.slideTo(testiMain.activeIndex);
});

testiThumbs.on('transitionStart', function(){
    testiMain.slideTo(testiThumbs.activeIndex);
});  
/*=============================================
=            Testimonial Slider End           =
=============================================*/

}
/*=============================================
=            VR Animation Start           =
=============================================*/

gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia();
mm.add("(max-width: 450px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.8, opacity: 1 },
            "80%": { scale: 2, opacity: 1 },
            "100%": { scale: 2.5, opacity: 0, ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 48+'%'},
            "20%": { width: 58+'%'},
            "40%": { width: 68+'%'},
            "60%": { width: 80+'%'},
            "80%": { width: 90+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 30%",
        end: "+=50%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 30%",
        end: "+=50%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width:451px) and (max-width: 649px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.6, opacity: 1 },
            "80%": { scale: 1.8, opacity: 1 },
            "100%": { scale: 2, opacity: 0, display:"none", ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 40+'%'},
            "20%": { width: 50+'%'},
            "40%": { width: 60+'%'},
            "60%": { width: 65+'%'},
            "80%": { width: 90+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width:650px) and (max-width: 767px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.6, opacity: 1 },
            "60%": { scale: 1.8, opacity: 1 },
            "80%": { scale: 2, opacity: 1 },
            "100%": { scale: 2.5, opacity: 0, display:"none", ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 34+'%'},
            "20%": { width: 40+'%'},
            "40%": { width: 50+'%'},
            "50%": { width: 60+'%'},
            "60%": { width: 68+'%'},
            "70%": { width: 75+'%'},
            "80%": { width: 85+'%'},
            "90%": { width: 90+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width:768px) and (max-width: 991px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.6, opacity: 1 },
            "80%": { scale: 1.8, opacity: 1 },
            "100%": { scale: 2, opacity: 0, display:"none", ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 45+'%'},
            "20%": { width: 55+'%'},
            "40%": { width: 60+'%'},
            "50%": { width: 65+'%'},
            "60%": { width: 70+'%'},
            "80%": { width: 80+'%'},
            "90%": { width: 90+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width:992px) and (max-width: 1199px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.6, opacity: 1 },
            "80%": { scale: 1.8, opacity: 1 },
            "100%": { scale: 2, opacity: 0, display:"none", ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 42+'%'},
            "20%": { width: 48+'%'},
            "40%": { width: 55+'%'},
            "50%": { width: 65+'%'},
            "60%": { width: 70+'%'},
            "70%": { width: 80+'%'},
            "80%": { width: 85+'%'},
            "90%": { width: 90+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 25%",
        end: "+=35%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width: 1200px) and (max-width: 1599px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.4, opacity: 1 },
            "60%": { scale: 1.6, opacity: 1 },
            "60%": { scale: 1.8, opacity: 1 },
            "70%": { scale: 2, opacity: 1 },
            "80%": { scale: 2.2, opacity: 1 },
            "90%": { scale: 2.4, opacity: 0 },
            "100%": { scale: 2.5, opacity: 0, ease:"inOut"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 40+'%'},
            "25%": { width: 50+'%'},
            "50%": { width: 60+'%'},
            "60%": { width: 70+'%'},
            "70%": { width: 80+'%' },
            "80%": { width:  100+'%'},
            "90%": { width:  100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 28%",
        end: "+=100%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 28%",
        end: "+=100%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width: 1600px) and (max-width: 1999px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.3, opacity: 1 },
            "40%": { scale: 1.5, opacity: 1 },
            "50%": { scale: 2, opacity: 1 },
            "60%": { scale: 2.2, opacity: 1 },
            "70%": { scale: 2.4, opacity: 1 },
            "80%": { scale: 2.6, opacity: 1 },
            "90%": { scale: 2.8, opacity: 0 },
            "100%": { scale: 3, opacity: 0, ease:"none"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 30+'%', borderRadius: 50},
            "25%": { width: 40+'%'},
            "40%": { width: 45+'%'},
            "50%": { width: 50+'%'},
            "60%": { width: 65+'%'},
            "70%": { width: 80+'%', borderRadius: 0},
            "80%": { width: 100+'%'},
            "90%": { width: 100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 28%",
        end: "+=120%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 28%",
        end: "+=120%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width: 2000px) and (max-width: 2499px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
            "0%": { scale: 1, opacity: 1 },
            "20%": { scale: 1.2, opacity: 1 },
            "40%": { scale: 1.5, opacity: 1 },
            "50%": { scale: 2, opacity: 1 },
            "60%": { scale: 2.2, opacity: 1 },
            "70%": { scale: 2.6, opacity: 1 },
            "80%": { scale: 3, opacity: 1 },
            "90%": { scale: 3.5, opacity: 0 },
            "100%": { scale: 3.8, opacity: 0, ease:"none"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 23+'%'},
            "25%": { width: 30+'%'},
            "40%": { width: 40+'%'},
            "50%": { width: 50+'%'},
            "60%": { width: 58+'%'},
            "70%": { width: 70+'%' },
            "80%": { width: 80+'%'},
            "90%": { width: 100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 28%",
        end: "+=100%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 28%",
        end: "+=100%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width: 2500px) and (max-width: 2999px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
                "0%": { scale: 1, opacity: 1 },
                "20%": { scale: 1.3, opacity: 1 },
                "40%": { scale: 1.5, opacity: 1 },
                "50%": { scale: 2, opacity: 1 },
                "60%": { scale: 2.5, opacity: 1 },
                "70%": { scale: 3, opacity: 1 },
                "80%": { scale: 3.5, opacity: 1 },
                "90%": { scale: 4, opacity: 0 },
                "100%": { scale: 4.3, opacity: 0, ease:"none"}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 22+'%'},
            "25%": { width: 30+'%'},
            "40%": { width: 38+'%'},
            "50%": { width: 48+'%'},
            "60%": { width: 60+'%'},
            "70%": { width: 70+'%' },
            "80%": { width: 80+'%'},
            "90%": { width: 100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 38%",
        end: "+=130%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 38%",
        end: "+=130%",
        scrub: 1,
        transformOrigin: "center center",
    })
});

mm.add("(min-width: 3000px) and (max-width: 3499px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
                "0%": { scale: 1, opacity: 1 },
                "20%": { scale: 2, opacity: 1 },
                "40%": { scale: 2.5, opacity: 1 },
                "50%": { scale: 3, opacity: 1 },
                "60%": { scale: 3.5, opacity: 1 },
                "70%": { scale: 4, opacity: 1 },
                "80%": { scale: 4.5, opacity: 0 },
                "90%": { scale: 4.8, opacity: 0 },
                "100%": { scale: 5, opacity: 0}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 20+'%'},
            "20%": { width: 40+'%'},
            "30%": { width: 48+'%'},
            "40%": { width: 55+'%'},
            "50%": { width: 60+'%'},
            "60%": { width: 70+'%'},
            "70%": { width: 82+'%'},
            "80%": { width: 100+'%'},
            "90%": { width: 100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 38%",
        end: "+=150%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 38%",
        end: "+=150%",
        scrub: 1,
        transformOrigin: "center center",
    })
});


mm.add("(min-width: 3500px) and (max-width: 4000px)", () => {
    const image = gsap.timeline()
        .to(".vr-wrapper img",
        {
            keyframes: {
                "0%": { scale: 1, opacity: 1 },
                "20%": { scale: 2, opacity: 1 },
                "40%": { scale: 2.5, opacity: 1 },
                "50%": { scale: 3, opacity: 1 },
                "60%": { scale: 3.5, opacity: 1 },
                "70%": { scale: 4, opacity: 1 },
                "80%": { scale: 4.5, opacity: 0 },
                "90%": { scale: 4.8, opacity: 0 },
                "100%": { scale: 5, opacity: 0}
            },
            transformOrigin: "center center",
        })

    const video = gsap.timeline()
        .to(".vr-wrapper custom-video",{
        keyframes: {
            "0%": { width: 18+'%'},
            "20%": { width: 35+'%'},
            "30%": { width: 40+'%'},
            "40%": { width: 48+'%'},
            "50%": { width: 55+'%'},
            "60%": { width: 60+'%'},
            "70%": { width: 80+'%'},
            "80%": { width: 100+'%'},
            "90%": { width: 100+'%'},
            "100%": { width: 100+'%'}
            },
        transformOrigin: "center center",
        })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: image,
        start: "top 38%",
        end: "+=150%",
        scrub: 1,
        markers: false,
        pin: true,
        transformOrigin: "center center",
    })
    ScrollTrigger.create({
        trigger: ".vr-wrapper",
        animation: video,
        start: "top 38%",
        end: "+=150%",
        scrub: 1,
        transformOrigin: "center center",
    })
});
/*=============================================
=            VR Animation End           =
=============================================*/

/*=============================================
=            Interactive Book Start           =
=============================================*/
const spider = gsap.timeline()
.to(".prallax-img",
{
    keyframes: {
    "0%": { scale: 1},
    "20%": { scale: 1.4},
    "40%": { scale: 1.8},
    "60%": { scale: 2.2},
    "80%": { scale: 2.6},
    "100%": { scale: 3}
    },
    transformOrigin: "center bottom",
})

ScrollTrigger.create({
    trigger: ".interactive-book-content",
    animation: spider,
    start: "top 50%",
    end: "bottom 50%",
    scrub: 1,
    markers: false,
    pin: false,
    transformOrigin: "center bottom",
})
/*=============================================
=            Interactive Book End           =
=============================================*/